import { useSelector } from 'react-redux';

import LicenseStatus from '../../../../components/LicenseStatus';

import { versionComparisonSelector } from '../../../../store/audit/selectors';

interface IComparisonStatusProps {
  isLeftVersion: boolean;
}

function ComparisonStatus({ isLeftVersion }: IComparisonStatusProps) {
  const { differenceMap, lpcoResponse } = useSelector(versionComparisonSelector);

  const leftStatus = lpcoResponse.status ?? '';
  const leftOgaStatus = lpcoResponse.ogaStatus ?? '';
  const leftOgaStatusInNationalLang = lpcoResponse.ogaStatusInNationalLang ?? '';

  const rightStatus = differenceMap['/status'] ? differenceMap['/status'].rightValue : lpcoResponse?.status ?? '';
  const rightOgaStatus = differenceMap['/ogaStatus']
    ? differenceMap['/ogaStatus'].rightValue
    : lpcoResponse?.ogaStatus ?? '';

  const rightOgaStatusInNationalLang = differenceMap['/ogaStatusInNationalLang']
    ? differenceMap['/ogaStatusInNationalLang'].rightValue
    : lpcoResponse?.ogaStatusInNationalLang ?? '';

  return (
    <LicenseStatus
      ogaStatusInNationalLang={isLeftVersion ? leftOgaStatusInNationalLang : (rightOgaStatusInNationalLang as string)}
      ogaStatus={isLeftVersion ? leftOgaStatus : (rightOgaStatus as string)}
      status={isLeftVersion ? leftStatus : (rightStatus as string)}
      size="sm"
    />
  );
}

export default ComparisonStatus;
